import { useNavigate, useSearchParams } from 'react-router-dom';
import { ContentPromotion } from './ContentPromotion/ContentPromotion';
import { useDirectCompanies } from './ContentPromotion/hooks/useDirectCompanies';
import { ContentPromotionSkeleton } from './ContentPromotion/parts/ContentPromotionSkeleton';

export const BusinessContentPromotion: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [query] = useSearchParams();
    const companyId = query.get('campaign-id');
    const { directCompanies, isLoading } = useDirectCompanies();
    const company = companyId
        ? directCompanies?.find((directCompany) => directCompany.id === Number(companyId))
        : directCompanies?.[0];

    if (isLoading) {
        return <ContentPromotionSkeleton />;
    }

    if (companyId) {
        return <ContentPromotion company={company} isEditMode />;
    }

    if (company) {
        navigate(`/promotion?campaign-id=${company.id}`, { replace: true });

        return <ContentPromotion company={company} isEditMode />;
    }

    return <ContentPromotion />;
};
